/* eslint-disable react/require-default-props, no-unused-vars */
import Drawer from '@groovehq/internal-design-system/lib/components/Drawer/UnmanagedDrawer'

const Footer = () => {
  return null
}
const SampleDrawer = ({ drawerResourceId, open, title, onExit }) => {
  const drawerTitle = title || 'Sample'
  return (
    <Drawer
      title={drawerTitle}
      open={open}
      onClose={onExit}
      footer={<Footer />}
    >
      Sample: {drawerResourceId}
    </Drawer>
  )
}

SampleDrawer.propTypes = {}

export default SampleDrawer
